import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // 显示加载状态
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-400">加载中...</div>
      </div>
    );
  }

  if (!user) {
    // 用户未登录，重定向到登录页面
    // 传递当前路径作为返回URL
    return <Navigate to={`/login?return_url=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  // 用户已登录，渲染子组件
  return children;
}